const colors = {
    background: {
        default: "#f8f9fa",
    },

    text: {
        primary: "#67748e",
        secondary: "#67748e",
    },

    transparent: "transparent",

    white: {
        main: "#ffffff",
    },

    black: {
        main: "#000000",
        light: "#141414",
    },

    // primary: {
    //     main: "#cb0c9f",
    //     dark: "#ad0a87",
    // },

    primary: {
        main: "#2152ff",
        light: "#21d4fd",
    },

    secondary: {
        main: "#8392ab",
        light: "#96a2b8",
    },

    info: {
        main: "#17c1e8",
        light: "#3acaeb",
    },

    success: {
        main: "#82d616",
        light: "#95dc39",
    },

    warning: {
        main: "#fbcf33",
        light: "#fcd652",
    },

    error: {
        main: "#ea0606",
        light: "#c70505",
    },

    light: {
        main: "#e9ecef",
        light: "#e9ecef",
    },

    dark: {
        main: "#344767",
        light: "#344767",
    },

    grey: {
        100: "#f8f9fa",
        200: "#e9ecef",
        300: "#dee2e6",
        400: "#ced4da",
        500: "#adb5bd",
        600: "#6c757d",
        700: "#495057",
        800: "#343a40",
        900: "#212529",
    },

    gradientPrimary: {
        main: "#7928ca",
        light: "#ff0080",
    },

    gradientSecondary: {
        main: "#627594",
        light: "#a8b8d8",
    },

    gradientInfo: {
        main: "#2152ff",
        light: "#21d4fd",
    },

    gradientSuccess: {
        main: "#17ad37",
        light: "#98ec2d",
    },

    gradientWarning: {
        main: "#f53939",
        light: "#fbcf33",
    },

    gradientError: {
        main: "#ea0606",
        light: "#ff667c",
    },

    gradientLight: {
        main: "#ced4da",
        light: "#ebeff4",
    },

    gradientDark: {
        main: "#141727",
        light: "#3a416f",
    },

    socialMediaFacebook: {
        main: "#3b5998",
        dark: "#344e86",
    },

    socialMediaTwitter: {
        main: "#55acee",
        dark: "#3ea1ec",
    },

    socialMediaInstagram: {
        main: "#125688",
        dark: "#0e456d",
    },

    socialMediaLinkedin: {
        main: "#0077b5",
        dark: "#00669c",
    },

    socialMediaPinterest: {
        main: "#cc2127",
        dark: "#b21d22",
    },

    socialMediaYoutube: {
        main: "#e52d27",
        dark: "#d41f1a",
    },

    socialMediaVimeo: {
        main: "#1ab7ea",
        dark: "#13a3d2",
    },

    socialMediaSlack: {
        main: "#3aaf85",
        dark: "#329874",
    },

    socialMediaDribbble: {
        main: "#ea4c89",
        dark: "#e73177",
    },

    socialMediaGithub: {
        main: "#24292e",
        dark: "#171a1d",
    },

    socialMediaReddit: {
        main: "#ff4500",
        dark: "#e03d00",
    },

    socialMediaTumblr: {
        main: "#35465c",
        dark: "#2a3749",
    },

    alertColorPrimary: {
        main: "#7928ca",
        state: "#d6006c",
        border: "#efb6e2",
    },

    alertColorSecondary: {
        main: "#627594",
        state: "#8ca1cb",
        border: "#dadee6",
    },

    alertColorInfo: {
        main: "#2152ff",
        state: "#02c6f3",
        border: "#b9ecf8",
    },

    alertColorSuccess: {
        main: "#17ad37",
        state: "#84dc14",
        border: "#daf3b9",
    },

    alertColorWarning: {
        main: "#f53939",
        state: "#fac60b",
        border: "#fef1c2",
    },

    alertColorError: {
        main: "#ea0606",
        state: "#ff3d59",
        border: "#f9b4b4",
    },

    alertColorLight: {
        main: "#ced4da",
        state: "#d1dae6",
        border: "#f8f9fa",
    },

    alertColorDark: {
        main: "#141727",
        state: "#2c3154",
        border: "#c2c8d1",
    },

    badgeColorPrimary: {
        main: "#f883dd",
        contrastText: "#a3017e",
    },

    badgeColorSecondary: {
        main: "#e4e8ed",
        contrastText: "#5974a2",
    },

    badgeColorInfo: {
        main: "#abe9f7",
        contrastText: "#08a1c4",
    },

    badgeColorSuccess: {
        main: "#cdf59b",
        contrastText: "#67b108",
    },

    badgeColorWarning: {
        main: "#fef5d3",
        contrastText: "#fbc400",
    },

    badgeColorError: {
        main: "#fc9797",
        contrastText: "#bd0000",
    },

    badgeColorLight: {
        main: "#ffffff",
        contrastText: "#c7d3de",
    },

    badgeColorDark: {
        main: "#8097bf",
        contrastText: "#1e2e4a",
    },

    // badgeColorInputColors: {
    //     borderColor: { main: "#d2d6da", focus: "#35d1f5" },
    //     boxShadow: "#81e3f9",
    //     error: "#fd5c70",
    //     success: "#66d432",
    // },

    sliderColorThumbBorderColor: { main: "#d9d9d9" },

    circleSliderColors: {
        main: "#d3d3d3",
    },

    tabsIndicatorBoxShadow: { main: "#ddd" },
};

export default colors;
